export function Share({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.2693 9.54762C14.9918 9.54762 14.7593 9.33762 14.7293 9.06012C14.5493 7.41012 13.6643 5.92512 12.2993 4.98012C12.0518 4.80762 11.9918 4.47012 12.1643 4.22262C12.3368 3.97512 12.6743 3.91512 12.9218 4.08762C14.5493 5.22012 15.5993 6.99012 15.8168 8.94762C15.8468 9.24762 15.6293 9.51762 15.3293 9.54762C15.3068 9.54762 15.2918 9.54762 15.2693 9.54762Z"
          fill="currentColor"
        />
        <path
          d="M2.80448 9.58503C2.78948 9.58503 2.76698 9.58503 2.75198 9.58503C2.45198 9.55503 2.23448 9.28503 2.26448 8.98503C2.46698 7.02753 3.50198 5.25753 5.11448 4.11753C5.35448 3.94503 5.69948 4.00503 5.87198 4.24503C6.04448 4.49253 5.98448 4.83003 5.74448 5.00253C4.39448 5.96253 3.51698 7.44753 3.35198 9.09003C3.32198 9.37503 3.08198 9.58503 2.80448 9.58503Z"
          fill="currentColor"
        />
        <path
          d="M11.9915 15.8251C11.069 16.2676 10.079 16.4926 9.04398 16.4926C7.96398 16.4926 6.93648 16.2526 5.97648 15.7651C5.70648 15.6376 5.60148 15.3076 5.73648 15.0376C5.86398 14.7676 6.19398 14.6626 6.46398 14.7901C6.93648 15.0301 7.43898 15.1951 7.94898 15.2926C8.63898 15.4276 9.34398 15.4351 10.034 15.3151C10.544 15.2251 11.0465 15.0676 11.5115 14.8426C11.789 14.7151 12.119 14.8201 12.239 15.0976C12.374 15.3676 12.269 15.6976 11.9915 15.8251Z"
          fill="currentColor"
        />
        <path
          d="M9.03785 1.50757C7.87535 1.50757 6.92285 2.45257 6.92285 3.62257C6.92285 4.79257 7.86785 5.73757 9.03785 5.73757C10.2079 5.73757 11.1529 4.79257 11.1529 3.62257C11.1529 2.45257 10.2079 1.50757 9.03785 1.50757Z"
          fill="currentColor"
        />
        <path
          d="M3.78785 10.4026C2.62535 10.4026 1.67285 11.3476 1.67285 12.5176C1.67285 13.6876 2.61785 14.6326 3.78785 14.6326C4.95785 14.6326 5.90285 13.6876 5.90285 12.5176C5.90285 11.3476 4.95035 10.4026 3.78785 10.4026Z"
          fill="currentColor"
        />
        <path
          d="M14.2131 10.4026C13.0506 10.4026 12.0981 11.3476 12.0981 12.5176C12.0981 13.6876 13.0431 14.6326 14.2131 14.6326C15.3831 14.6326 16.3281 13.6876 16.3281 12.5176C16.3281 11.3476 15.3831 10.4026 14.2131 10.4026Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
